/*
 * App Entry Point
 *	Require whatever you need here!
 */
// REACT
var React = require('react');
var ReactDOM = require('react-dom');

require("./../../bower_components/okaynav/dist/js/jquery.okayNav-min.js");

require("./../../bower_components/featherlight/release/featherlight.min.js");
require("./../../bower_components/featherlight/release/featherlight.gallery.min.js");

var str_replace = require('locutus/php/strings/str_replace');
var MemberList = require('./components/memberList.jsx');
var ShowPosts = require('./components/showPosts.jsx');

// Load Stylessheets
require("./../scss/app.scss");

// There are two menus, one for desktop and tablet, and another one for mobile
if($(window).width() < 768) {
    $('#nav-main-mobile').okayNav({
        parent : '', // will call nav's parent() by default
        toggle_icon_class : 'okayNav__menu-toggle',
        toggle_icon_content: '<span /><span /><span />',
        align_right: true, // If false, the menu and the kebab icon will be on the left
        swipe_enabled: false, // If true, you'll be able to swipe left/right to open the navigation
        threshold: 50, // Nav will auto open/close if swiped >= this many percent
        beforeOpen : function() {}, // Will trigger before the nav gets opened
        afterOpen : function() {}, // Will trigger after the nav gets opened
        beforeClose : function() {}, // Will trigger before the nav gets closed
        afterClose : function() {}, // Will trigger after the nav gets closed
        itemHidden: function() {}, // Will trigger after an item moves to the hidden navigation
        itemDisplayed: function() {} // Will trigger after an item moves to the visible navigation
    });
} else {
    $('#nav-main').okayNav({
        parent : '', // will call nav's parent() by default
        toggle_icon_class : 'okayNav__menu-toggle',
        toggle_icon_content: '<span /><span /><span />',
        align_right: true, // If false, the menu and the kebab icon will be on the left
        swipe_enabled: false, // If true, you'll be able to swipe left/right to open the navigation
        threshold: 50, // Nav will auto open/close if swiped >= this many percent
        beforeOpen : function() {}, // Will trigger before the nav gets opened
        afterOpen : function() {}, // Will trigger after the nav gets opened
        beforeClose : function() {}, // Will trigger before the nav gets closed
        afterClose : function() {}, // Will trigger after the nav gets closed
        itemHidden: function() {}, // Will trigger after an item moves to the hidden navigation
        itemDisplayed: function() {} // Will trigger after an item moves to the visible navigation
    });
}

function scrollToPosition(hash, callback) {
    if(hash.includes("#") && hash != "#") {
        if(document.getElementById(hash) || $('a[name='+str_replace("#", "", hash)+']')) {

            var element = $(hash);
            if($('a[name='+str_replace("#", "", hash)+']')) {
                element = $('a[name='+str_replace("#", "", hash)+']').closest( ".elementor-section" );
            }

            var navbar = $("#header").outerHeight();
            var offset = element.offset().top;

            $('body').animate({
                scrollTop: Math.round(offset - navbar)
            }, 1000, "linear");

            if(callback) {
                callback();
            }

            return false;
        }
    }
}

function moveMenu() {
    if(!$('.okayNav__menu-toggle').hasClass('okay-invisible') && $('#top-menu').children('li').length > 0) {
        $('#top-menu').css('padding-right', '50px');
    } else {
        $('#top-menu').css('padding-right', '');
    }
}

// function footerPosition() {
//     $('footer').css({position: 'relative'});

//     var footerHeight = $('footer').offset().top;
//     var windowHeight = $(window).outerHeight();

//     if(footerHeight < windowHeight) {
//         $('footer').css({position: 'absolute', bottom: '-1px', width: '100%'});
//     }
// }

// This function will add a class which will trigger the CSS transitions
function addLoadedClass() {
    $('.okayNav__menu-toggle').addClass('loaded');
    setTimeout(function() {
        $('.okayNav__nav--visible').addClass('loaded');
    }, 3000);
}

$(window).ready(function() {

    // GALLERY
    /*
    $.each( $( ".pm-gallery").find('.gallery-item'), function() {
        console.log( $( this ).find('a').attr('href') ); // IMAGE
        console.log( $( this ).find('.gallery-caption').text() ); // CAPTION
    });*/

    jQuery(window).on('hashchange', function(e){
        e.preventDefault();
        var hash = window.location.hash;
        if(hash != "" && hash.indexOf("#") != -1) {
            scrollToPosition(hash);
            // Iterate over all nav links, setting the "selected" class as-appropriate.

            $( "a" ).each(function() {
                var that = $( this );
                that.removeClass('active');
                that.parent().removeClass('active');

                if(that.attr( "href" ) === hash) {
                    that.addClass('active');
                    that.parent().addClass('active');
                }
            });
        }
    });
    jQuery(window).trigger('hashchange');

    // This code triggers a function after the resize/orientationchange event has finished
    var resizeTimer;
    $(window).on('resize orientationchange', function(e) {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            moveMenu();
        }, 250);
    });

    $('.pm-gallery a').featherlightGallery({
        previousIcon: '«',
        nextIcon: '»',
        galleryFadeIn: 300,
        openSpeed: 300
    });

    $('.pm-gallery .gallery-icon').click(function(e) {
        e.stopPropagation();
        console.log('trigger click');
        $( this ).find('a').click();
    });

    $('.pm-gallery .gallery-icon a').click(function(e) {
        // STOP EVENT BUBBLING :/
        e.stopPropagation();
    });

    if($(".elementor-button").length > 0 && !$('body').hasClass('home')) {
        // We are in a page with posts
        var count = 0;
        $('.elementor-widget-button').attr('href', '');
        if($('.two-posts-row').length <= 4) {
            $('.elementor-widget-button').css('display', 'none');
        }
        //$('.elementor-shortcode').each(function() {
        //
        //});
        $('.two-posts-row').each(function() {
            count++;
            if(count > 8) {
                $(this).css("display", "none");
            }
        });

        $('.elementor-button-link').on('click', function() {
            var count = 0;
            $('.two-posts-row').each(function() {
                if($(this).css("display") == "none") {
                    if(count < 4) {
                        $(this).css("display", "flex");
                    }
                    count++;
                }
            });
            if(count == 4) {
                // There are no more posts
                $('.elementor-widget-button').css('display', 'none');
            }
        });
    }

    if($('body').hasClass('single-tiding') || $('body').hasClass('single-post')) {
        if(!document.getElementById('bgImage')) {
            $('.site-content-contain').css('padding-top', '160px');
        }
    }

    // This code triggers a function after the resize/orientationchange event has finished
    var resizeTimer;
    $(window).on('resize orientationchange', function(e) {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            moveMenu();
        }, 250);
    });

    // When the page is loaded for the first time, wait 4 seconds and then trigger this function
    //setTimeout(function() {
        addLoadedClass();
    //}, 3000);
    // Close menu when navigation is clicked
    $('ul#top-menu li a, ul.okayNav__nav--invisible li a').click(function() {
        if($('ul.okayNav__nav--invisible').hasClass('nav-open')) {
            $('ul.okayNav__nav--invisible').removeClass('nav-open').css('transform', 'translateX(100%)');
            $('.okayNav__menu-toggle').removeClass('icon--active');
        }
    });

    // Function to check if the footer is correctly shown
    // footerPosition();
    // $(window).on('orientationchange', function() {
    //     footerPosition();
    // });

    /***********************/
    /* Scrolling functions */
    /***********************/

    // Scroll to members list when clicking a pagination element
    if(document.getElementById('memberList')) {
        var memberListID = $('#memberList').offset().top;
        var navbar = $('header').height();
        //scrollToMembers();
        $('#memberList ul.pagination > li > a').click(function() {
            if($(this).css('cursor') != 'not-allowed') {
                $('body').animate({
                    scrollTop: memberListID - navbar
                }, 1000, "linear");
            }
        });
    }

    // Scroll to the corresponding tab when a tab is clicked so the page doesn't jump when another tab is closed
    if($(window).width() < 768) {
        $('.elementor-tab-title.elementor-tab-mobile-title').click(function() {
            var tab = $(this).offset().top - $(this).height();
            $('body').animate({
                scrollTop: tab - navbar
            }, 1000, "linear");
        });
    }

    /***********************/
});

if(document.getElementById('memberList')) {
    ReactDOM.render(<MemberList />, document.getElementById('memberList'));
}

if(document.getElementById('showPosts')) {
    var last_three = $('#showPosts').attr('data-last-three');
    if(last_three == 'false') {
        ReactDOM.render(<ShowPosts lastThreePosts='false' />, document.getElementById('showPosts'));

        $('.two-posts-row').each(function() {
            $(this).css('display', 'block');
        });

        var titleColor = $('#posts_divider span').css('border-top-color');
        $('#showPosts .section-title h2').css('color', titleColor);

    } else {
        ReactDOM.render(<ShowPosts lastThreePosts='true' />, document.getElementById('showPosts'));
    }

}

//if(document.getElementById('showPosts')) {
//    ReactDOM.render(<ShowPosts posts="-1" />, document.getElementById('showPosts'));
//}

//window.log = (message) => console.log(message);
